import React, { useState, useEffect } from "react";
import { round1000 } from "core/utils/general";
import { ArrowCta } from "hero/components/ArrowCta";
import AffixedCountdown from "hero/components/AffixedCountdown";
import { Id } from "core/utils";
var CtaWithCountdown = function (_a) {
    var cta = _a.cta, countdown = _a.countdown, onCountdownEnd = _a.onCountdownEnd, className = _a.className;
    var _b = useState(round1000(countdown.duration)), currentDuration = _b[0], setCurrentDuration = _b[1];
    useEffect(function () {
        if (currentDuration <= -1000) {
            if (onCountdownEnd)
                onCountdownEnd();
            return;
        }
        var intervalId = setInterval(function () {
            setCurrentDuration(currentDuration - 1000);
        }, 1000);
        return function () { return clearInterval(intervalId); };
    }, [currentDuration]);
    if (currentDuration > -1000) {
        return (React.createElement(AffixedCountdown, { duration: currentDuration, prefix: countdown.prefix, suffix: countdown.suffix, className: className }));
    }
    if (cta) {
        return (React.createElement(ArrowCta, { data: cta, "data-action": Id.action.dynamicHeroArrowCta, className: className }));
    }
    return null;
};
export default CtaWithCountdown;
